exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".removed-trademarks_removed-trademarks_2gcSr {\n    opacity: 0.75;\n}\n", ""]);

// exports
exports.locals = {
	"removed-trademarks": "removed-trademarks_removed-trademarks_2gcSr",
	"removedTrademarks": "removed-trademarks_removed-trademarks_2gcSr"
};